
import { Options, Vue } from "vue-class-component";
import ruMessages from "devextreme/localization/messages/ru.json";
import { locale, loadMessages } from "devextreme/localization";

import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import { triggerCancel, triggerOk } from "./services/keyboardActions";

@Options({
  components: { AuthLayout, MainLayout },
})
export default class App extends Vue {
  get layout() {
    if ((this.$route as any).meta.layout) {
      return (this.$route as any).meta.layout + "-layout";
    } else return "PageNotFound";
  }

  created() {
    loadMessages(ruMessages);
    locale("ru");
  }

  mounted() {
    window.addEventListener("keydown", this.handleKeydown, true);
  }

  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown, true);
  }

  handleKeydown(e: KeyboardEvent) {
    if (e.key === "Enter") {
      triggerOk();
    }

    if (e.key === "Escape") {
      triggerCancel();
    }
  }
  /*
   get currentUser(){
     return (this as any).$store.state.auth.user;
   }

   get showAdminBoard() {
     return true;
   }

   get showModeratorBoard(){
     return true;
   }

   logOut() {
      (this as any).$store.dispatch('auth/logout');
      this.$router.push('/login');
    }*/
}
